import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Stack, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect, useState } from 'react';
import PublicNavBar from '../../Components/public-navbar/publicNavBar';
import ProjectResult from '../../Components/PublicSite/ProjectResult';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import CircularProgress from '@mui/material/CircularProgress';

function PublicProjects(props) {

    const [yearFilter, setYearFilter] = useState('');
    const [semesterFilter, setSemesterFilter] = useState('');
    const [results, setResults] = useState([]);
    const [searchString, setSearchString] = useState('');
    const [loading, setLoading] = useState(false);

    async function fetchData(searchString, yearFilter, semesterFilter) {
        // reset results on the page
        setResults([]);

        setLoading(true);

        const res = await fetch(`${process.env.REACT_APP_API_HOST}/api/projects/search`, {
            method: 'POST',
            body: JSON.stringify({
                query: searchString,
                year: yearFilter,
                semester: semesterFilter
            }),
            headers: {
                'Content-Type': 'application/json'
            },
        });

        if (!res.ok) {
            console.error('failed to fetch all projects', res);
            setLoading(false);
            return;
        }

        const json = await res.json();
        // console.log('setting results to: ' + json);
        setResults(json);
        setLoading(false);
    }

    useEffect(() => {
        fetchData('', yearFilter, semesterFilter);
    }, [yearFilter, semesterFilter]);

    return (
        <Box>
            <PublicNavBar />
            <Box sx={{ height: 'calc(100vh - 52.5px)', display: 'flex', flexDirection: 'row' }}>
                <Stack sx={{ width: '100%', height: '100%' }}>
                    <Box>
                        <Typography variant='h3' sx={{ pl: 5, pt: 5 }}>
                            Past Projects
                            <Box sx={{ background: 'none repeat scroll 0 0 #fc0', bottom: '-10px', content: '""', display: 'block', height: '4px', position: 'relative', width: '60px', mb: 5 }}></Box>
                        </Typography>
                    </Box>
                    <Box sx={{ height: '140px', width: '100%', backgroundColor: '#FFC904', display: 'flex', flexDirection: 'row', justifyContent: 'right', alignItems: 'center', pr: '7rem', minHeight: '140.02px' }}>
                        {/* Search Bar */}
                        <Typography variant='h4' sx={{ mr: 8 }}>Search Previous Projects</Typography>
                        <input type='text' placeholder='Search...' value={searchString} onInput={e => setSearchString(e.target.value)} onKeyDown={e => { if (e.keyCode === 13) { fetchData(searchString, yearFilter, semesterFilter) } }} style={{ borderRadius: '5px', mt: '8px', mr: '16px', ml: '5px', borderTopRightRadius: 0, borderBottomRightRadius: 0, height: '3rem', width: '25%', fontSize: '18px', color: 'black', borderColor: 'black', }} />
                        <Button onClick={() => fetchData(searchString, yearFilter, semesterFilter)} sx={{ backgroundColor: 'black', borderTopLeftRadius: 0, borderBottomLeftRadius: 0, height: '3rem' }}><SearchIcon sx={{ color: 'white', p: 0, m: 0, fontSize: '30px' }} /></Button>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', minHeight: 'calc(100vh - 332.5px)' }}>
                        <Box sx={{ backgroundColor: 'black', width: '20%', height: '100%', p: 4, pt: 8 }}>
                            <Typography variant='h5' sx={{ color: '#FFC904' }}>Filters</Typography>
                            <Box sx={{ background: 'none repeat scroll 0 0 #fc0', bottom: '-6px', content: '""', display: 'block', height: '4px', position: 'relative', width: '35px', mb: 5 }}></Box>
                            <Box sx={{ minWidth: '100%', display: 'flex', flexDirection: 'column' }}>
                                <FormControl sx={{ minWidth: '100%' }}>
                                    <Select
                                        id='semesterSelect'
                                        displayEmpty
                                        value={semesterFilter}
                                        onChange={e => setSemesterFilter(e.target.value)}
                                        sx={{ color: 'black', backgroundColor: 'white', width: '100%', minWidth: '100%' }}
                                    >
                                        <MenuItem value=""><em>Semester</em></MenuItem>
                                        <MenuItem value="Fall">Fall</MenuItem>
                                        <MenuItem value="Spring">Spring</MenuItem>
                                        <MenuItem value="Summer">Summer</MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl sx={{ minWidth: '100%' }}>
                                    <Select
                                        id='yearSelect'
                                        displayEmpty
                                        value={yearFilter}
                                        onChange={e => setYearFilter(e.target.value)}
                                        sx={{ color: 'black', backgroundColor: 'white', width: '100%', minWidth: '100%', my: 3 }}
                                    >
                                        <MenuItem value=""><em>Year</em></MenuItem>
                                        {generateYearsStartingAt(2018)}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>
                        <Box sx={{ width: '80%', overflowY: 'auto' }}>
                            <Typography variant='h4' sx={{ pl: 8, pt: 8 }}>
                                Search Results
                                <Box sx={{ background: 'none repeat scroll 0 0 #fc0', bottom: '-10px', content: '""', display: 'block', height: '4px', position: 'relative', width: '60px', mb: 5 }}></Box>
                            </Typography>

                            {/* Box to hold search results */}
                            <Box sx={{ pl: 8 }}>
                                {loading ? (
                                    <Fade
                                        in={loading}
                                        style={{
                                            transitionDelay: loading ? '200ms' : '0ms',
                                        }}
                                        unmountOnExit
                                    >
                                        <CircularProgress />
                                    </Fade>
                                ) : (
                                    displayResults(results)
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Stack>
            </Box>
        </Box>
    );
}

function displayResults(results) {
    if (!results || results.length === 0) {
        return <Typography variant='h5'>No Results.</Typography>
    }
    
    return results.map((result, i) => <ProjectResult result={result} key={`result${i}`} />)
}

function generateYearsStartingAt(startYear) {
    const endYear = new Date().getFullYear()

    const years = [];

    for (let curYear = startYear; curYear <= endYear; curYear++) {
        years.push(<MenuItem value={curYear} key={`menuItemYear${curYear}`}>{curYear}</MenuItem>)
    }

    return years;
}

export default PublicProjects;